import { createContext, useContext, useState, useEffect } from 'react'
import { useAuth } from './AuthContext'

const DevModeContext = createContext({ devMode: false, toggleDevMode: () => {} })

const STORAGE_KEY = 'kidase.markingMode'

export function DevModeProvider({ children }) {
  const { isTester } = useAuth()
  const [devMode, setDevMode] = useState(() => {
    // URL param wins (and latches on); otherwise restore the persisted choice.
    const params = new URLSearchParams(window.location.search)
    if (params.get('marking') === 'true') return true
    try {
      return localStorage.getItem(STORAGE_KEY) === 'true'
    } catch {
      return false
    }
  })

  // Persist so marking mode survives sign-in redirects and reloads.
  // The header USER/DEV toggle only exists on localhost, so without this a
  // deployed tester who loses the ?marking=true param would be stranded.
  useEffect(() => {
    try {
      localStorage.setItem(STORAGE_KEY, devMode ? 'true' : 'false')
    } catch {
      // ignore storage failures (private mode, etc.)
    }
  }, [devMode])

  return (
    <DevModeContext.Provider value={{ devMode: devMode && (import.meta.env.DEV || isTester), toggleDevMode: () => setDevMode(p => !p) }}>
      {children}
    </DevModeContext.Provider>
  )
}

export function useDevMode() {
  return useContext(DevModeContext)
}
